// FiskDa — Den store kloke boken
// Komplett datagrunnlag for fiskeleksikon og fiskeuttrykk-ordbok.
//
// Bilder: legg .jpg/.png i public/fish/ med samme navn som "image"-feltet.
// Hvis bildet mangler, viser appen et placeholder-omriss automatisk.
// Tekstene er korte faktabaserte avsnitt — rediger fritt.

export const FISH_GUIDE = {
  salt: [
    {
      id: 'torsk',
      name: 'Torsk',
      latin: 'Gadus morhua',
      image: 'fish/torsk.webp',
      summary:
        'Torsken er en av Norges viktigste matfisker og kjennes på skjegget under haken og den lyse sidelinjen. Den lever både ute i havet (skrei) og mer stasjonært langs kysten (kysttorsk). Glupsk rovfisk som tar både agn, pilk og jigg.',
    },
    {
      id: 'lyr',
      name: 'Lyr',
      latin: 'Pollachius pollachius',
      image: 'fish/lyr.webp',
      summary:
        'Lyr er en rask og kampvillig torskefisk med tydelig underbitt og en mørk, buet sidelinje. Den jakter ofte høyt i vannet over tareskog og rev, og tar gjerne wobbler og jigg i fart.',
    },
    {
      id: 'sei',
      name: 'Sei',
      latin: 'Pollachius virens',
      image: 'fish/sei.webp',
      summary:
        'Seien er en sterk stimfisk med rett, lys sidelinje og kraftig kropp. Ungfisk (mort) står nær land, mens storseien jakter i stim ute på revkanter. Kjent for harde rykk og lange utløp.',
    },
    {
      id: 'makrell',
      name: 'Makrell',
      latin: 'Scomber scombrus',
      image: 'fish/makrell.webp',
      summary:
        'Makrellen er en glinsende, strømlinjeformet stimfisk med tigerstriper på ryggen. Den kommer inn til kysten om sommeren og tas lett på makrellforfang eller liten jigg. Svært god matfisk fersk.',
    },
    {
      id: 'laks-vill',
      name: 'Laks (vill)',
      latin: 'Salmo salar',
      image: 'fish/laks.webp',
      summary:
        'Atlanterhavslaksen vokser opp i havet og vandrer tilbake til elva for å gyte. Sølvblank i sjøen, mørkere i elv. En av verdens mest ettertraktede sportsfisker, fisket med flue, sluk og mark i elv.',
    },
    {
      id: 'sjoorret',
      name: 'Sjøørret',
      latin: 'Salmo trutta',
      image: 'fish/sjoorret.webp',
      summary:
        'Sjøørret er ørret som vandrer ut i sjøen for å beite. Sølvblank med svarte prikker, kraftig og utholdende. Populær å fiske fra land langs kysten, særlig vår og høst.',
    },
    {
      id: 'kveite',
      name: 'Kveite',
      latin: 'Hippoglossus hippoglossus',
      image: 'fish/kveite.webp',
      summary:
        'Kveita er verdens største flatfisk og kan bli flere hundre kilo. Den ligger på bunnen på dypt vann og er en drømmefangst for mange. Fiskes med stor jigg eller naturagn nær bunnen.',
    },
    {
      id: 'breiflabb',
      name: 'Breiflabb',
      latin: 'Lophius piscatorius',
      image: 'fish/breiflabb.webp',
      summary:
        'Breiflabben er en bunnlevende rovfisk med enormt gap og en "fiskestang" på hodet som lokker byttet. Ser uhyggelig ut, men regnes som en delikatesse. Fanges oftest som bifangst på bunn.',
    },
    {
      id: 'hyse',
      name: 'Hyse',
      latin: 'Melanogrammus aeglefinus',
      image: 'fish/hyse.webp',
      summary:
        'Hysa kjennes på den svarte flekken over brystfinnen og den mørke sidelinjen. En torskefisk som står nær bunn på sand og mudder. Mild og fin matfisk, ofte tatt på bunnsnøre.',
    },
    {
      id: 'brosme',
      name: 'Brosme',
      latin: 'Brosme brosme',
      image: 'fish/brosme.webp',
      summary:
        'Brosma er en ålelignende torskefisk med én lang ryggfinne og ett skjegg. Den lever dypt på hard bunn og rev. Seig kjemper, fast og god på tallerkenen.',
    },
    {
      id: 'hvitting',
      name: 'Hvitting',
      latin: 'Merlangius merlangus',
      image: 'fish/hvitting.webp',
      summary:
        'Hvitting er en slank torskefisk uten skjegg, vanlig på grunt vann langs kysten. Tar villig agn og er en fin nybegynnerfisk fra brygge og strand.',
    },
    {
      id: 'rodspette',
      name: 'Rødspette',
      latin: 'Pleuronectes platessa',
      image: 'fish/rodspette.webp',
      summary:
        'Rødspetta er en flatfisk med tydelige oransje prikker på oversiden. Den ligger nedgravd på sandbunn og tas på mark eller reke nær bunnen. Svært god matfisk.',
    },
    {
      id: 'skrubbe',
      name: 'Skrubbe',
      latin: 'Platichthys flesus',
      image: 'fish/skrubbe.webp',
      summary:
        'Skrubba er en hardfør flatfisk som tåler brakkvann og går langt opp i elvemunninger. Ru hud langs sidelinjen. Vanlig fangst på sand- og mudderbunn nær land.',
    },
    {
      id: 'uer',
      name: 'Uer',
      latin: 'Sebastes norvegicus',
      image: 'fish/uer.webp',
      summary:
        'Ueren er knallrød med store øyne og giftige piggstråler i finnene. Den lever dypt og blir svært gammel. Håndteres med forsiktighet på grunn av piggene. Regnet som en delikatesse.',
    },
    {
      id: 'steinbit',
      name: 'Steinbit',
      latin: 'Anarhichas lupus',
      image: 'fish/steinbit.webp',
      summary:
        'Steinbiten har kraftige tenner som knuser skjell og krabber. Bunnlevende på hard bunn, kjent for et fast og smakfullt kjøtt. Forsiktig med fingrene ved kroking.',
    },
    {
      id: 'horngjel',
      name: 'Horngjel',
      latin: 'Belone belone',
      image: 'fish/horngjel.webp',
      summary:
        'Horngjel er en lang, smal sølvfisk med spisst nebb og grønne bein. Kommer inn til kysten om våren samtidig med makrellen. Sprek på stang, og overraskende god mat.',
    },
    {
      id: 'pigghaa',
      name: 'Pigghå',
      latin: 'Squalus acanthias',
      image: 'fish/pigghaa.webp',
      summary:
        'Pigghå er en liten haiart med en giftig pigg foran hver ryggfinne. Går ofte i stim og kan gi hektisk fiske. Krever varsom håndtering. Tradisjonelt brukt til "håkjerring" og fish and chips.',
    },
    {
      id: 'lange',
      name: 'Lange',
      latin: 'Molva molva',
      image: 'fish/lange.webp',
      summary:
        'Langa er en lang, slank torskefisk med ett skjegg under haken og én lang ryggfinne. Den lever dypt på hard bunn og rev, ofte sammen med brosme. Tas på pilk og bunnsnøre, og gir fast, hvitt og velsmakende kjøtt.',
    },
    {
      id: 'lysing',
      name: 'Lysing',
      latin: 'Merluccius merluccius',
      image: 'fish/lysing.webp',
      summary:
        'Lysingen er en slank, sølvgrå torskefisk med stor munn og kraftige tenner. Den jakter aktivt på dypt vann og regnes som en fin matfisk med mildt, hvitt kjøtt. Tas oftest på dorg eller bunnsnøre nær revkanter.',
    },
  ],

  fresh: [
    {
      id: 'orret',
      name: 'Ørret',
      latin: 'Salmo trutta',
      image: 'fish/orret.webp',
      summary:
        'Ørreten er Norges mest utbredte ferskvannsfisk og finnes i nesten alle vann og elver. Brunlig med røde og svarte prikker. Fiskes med flue, sluk og mark — en klassiker i fjellvann.',
    },
    {
      id: 'roye',
      name: 'Røye',
      latin: 'Salvelinus alpinus',
      image: 'fish/roye.webp',
      summary:
        'Røya er en laksefisk fra kalde, klare vann, ofte i høyfjellet og nord i landet. Kjennes på lyse prikker på mørk bunn og oransje buk i gytetiden. Tåler kulde bedre enn de fleste arter.',
    },
    {
      id: 'abbor',
      name: 'Abbor',
      latin: 'Perca fluviatilis',
      image: 'fish/abbor.webp',
      summary:
        'Abboren kjennes på de mørke tverrstripene og den piggete ryggfinnen. Stimfisk som jakter i grupper, svært populær blant barn og pilkefiskere. Fast, hvitt og godt kjøtt.',
    },
    {
      id: 'gjedde',
      name: 'Gjedde',
      latin: 'Esox lucius',
      image: 'fish/gjedde.webp',
      summary:
        'Gjedda er ferskvannets rovdyr — lang og torpedoformet med et gap fullt av tenner. Den ligger i bakhold ved vegetasjon og hugger eksplosivt. Spennende på store sluker og jerkbaits.',
    },
    {
      id: 'laks-elv',
      name: 'Laks (elv)',
      latin: 'Salmo salar',
      image: 'fish/laks.webp',
      summary:
        'I elva er laksen på vei til gyteplassene og slutter å spise — den hugger av instinkt og irritasjon. Norges store sportsfiskeklenodium, fisket med flue og sluk i strie elver.',
    },
    {
      id: 'sik',
      name: 'Sik',
      latin: 'Coregonus lavaretus',
      image: 'fish/sik.webp',
      summary:
        'Siken er en sølvblank laksefisk med liten munn som beiter på dyreplankton og insekter. Vanlig i større innsjøer. Tradisjonelt garnfiske, men tas også på små fluer. Ettertraktet røkt.',
    },
    {
      id: 'harr',
      name: 'Harr',
      latin: 'Thymallus thymallus',
      image: 'fish/harr.webp',
      summary:
        'Harren kjennes lett på den store, fargerike seilryggfinnen. Den står i strømmende vann og tar tørrflue elegant fra overflaten. En favoritt blant fluefiskere, særlig i innlandselver.',
    },
    {
      id: 'mort',
      name: 'Mort',
      latin: 'Rutilus rutilus',
      image: 'fish/mort.webp',
      summary:
        'Morten er en vanlig karpefisk med sølvblanke sider og røde øyne. Den går i store stimer og tar lett mark og deig. Fin agnfisk og en typisk "første fisk" for mange.',
    },
    {
      id: 'brasme',
      name: 'Brasme',
      latin: 'Abramis brama',
      image: 'fish/brasme.webp',
      summary:
        'Brasma er en høyrygget karpefisk med messingfarget glans og slimete hud. Den bunnbeiter i stimer i næringsrike vann. Tas på mark og bunnmete, ofte i lavlandets innsjøer.',
    },
    {
      id: 'karpe',
      name: 'Karpe',
      latin: 'Cyprinus carpio',
      image: 'fish/karpe.webp',
      summary:
        'Karpen er en stor, sterk og smart karpefisk med skjegg ved munnen. Den blir svært gammel og kan vokse seg tung. Et eget fiskeri med boilies og bunnmete, kjent for lange fighter.',
    },
    {
      id: 'gjorr',
      name: 'Gjørs',
      latin: 'Sander lucioperca',
      image: 'fish/gjorr.webp',
      summary:
        'Gjørsen er en slank rovfisk i abborfamilien med store, lysømfintlige øyne. Den jakter i grumset vann og i skumringen. Ettertraktet matfisk, fanges på jigg og wobbler dypt.',
    },
    {
      id: 'lake',
      name: 'Lake',
      latin: 'Lota lota',
      image: 'fish/lake.webp',
      summary:
        'Laken er den eneste torskefisken i ferskvann, med ett skjegg og ålelignende bakkropp. Den er aktiv om vinteren og jakter på bunnen i kaldt vann. Tas ofte på isfiske med død agnfisk.',
    },
  ],
};

// Fiskeuttrykk — ordbok. Sortér alfabetisk i visningen.
export const FISHING_TERMS = [
  { term: 'Agn', definition: 'Naturlig lokkemat som mark, reke eller fisk som settes på kroken for å lokke fisk.' },
  { term: 'Bakslag', definition: 'Når snøret floker seg på snella under kast, typisk på multiplikatorsnelle.' },
  { term: 'Bunnsnøre', definition: 'Rigg med søkke som legges på bunnen, brukt til torsk, hyse og flatfisk.' },
  { term: 'Catch and release', definition: 'Å sette fisken tilbake i vannet levende etter fangst, ofte av hensyn til bestanden.' },
  { term: 'Dorging', definition: 'Å fiske med agn eller sluk som dras etter en båt i fart.' },
  { term: 'Dropshot', definition: 'Finfiskerigg der kroken sitter over søkket, slik at agnet svever fritt over bunnen.' },
  { term: 'Engelskmann', definition: 'En massiv floke eller et skikkelig krøll på fiskesena, ofte som følge av et realt «snatremål» (backlash) på en multiplikatorsnelle, eller at sena har tvunget seg inn i en umulig knute under overflaten.' },
  { term: 'Fluefiske', definition: 'Fiskemetode der en vektløs flue kastes ut ved hjelp av tyngden i fluesnøret.' },
  { term: 'Forfang', definition: 'Den tynne snørbiten mellom hovedsnøre og krok/flue, ofte mindre synlig for fisken.' },
  { term: 'Gyting', definition: 'Når fisken legger og befrukter rogn for å formere seg, ofte på faste plasser og tider.' },
  { term: 'Haill', definition: 'Tradisjonelt nordnorsk uttrykk for den magiske fiskelykken som skal komme av å ha hatt samleie kort tid før man drar på havet. Etter folketroen er reglene strenge: det bør ha skjedd for under 48 timer siden (ferskt haill), og man må ikke vaske seg — da vasker man bort lykken. Har det gått mer enn 72 timer, regnes det som utgått «gammalhaill».' },
  { term: 'Hugg', definition: 'Det øyeblikket fisken biter på agnet eller sluken.' },
  { term: 'Jigg', definition: 'Bløt gummiagn på blyhode som fiskes med rykkvise bevegelser nær bunnen.' },
  { term: 'Jerkbait', definition: 'Stor, hard agn uten egenbevegelse som gis liv gjennom rykk i stanga, mye brukt på gjedde.' },
  { term: 'Knute', definition: 'Festemåten mellom snøre og krok, sluk eller virvel. Riktig knute er avgjørende for styrken.' },
  { term: 'Kroking', definition: 'Når kroken setter seg fast i fiskens munn etter et hugg.' },
  { term: 'Mort (smått)', definition: 'Småfisk som brukes som levende eller død agn for rovfisk.' },
  { term: 'Meite', definition: 'Tradisjonelt fiske med fløyt, krok og agn, ofte fra land.' },
  { term: 'Pilk', definition: 'Tungt metallagn som fiskes vertikalt med opp- og nedbevegelser, klassisk til torsk og sei.' },
  { term: 'Pirk', definition: 'Liten pilk eller blink brukt til isfiske og smårovfisk.' },
  { term: 'Sjøørretblink', definition: 'Slank, blank sluk laget for å etterligne småfisk, brukt i sjøørretfiske fra land.' },
  { term: 'Sluk', definition: 'Metallagn som roterer eller vrikker i vannet og etterligner en byttefisk.' },
  { term: 'Snelle', definition: 'Mekanismen på stanga som holder og spoler inn snøret. Finnes som snurre-, flue- og multiplikatorsnelle.' },
  { term: 'Snøre', definition: 'Linen som forbinder stang og agn. Finnes som nylon (mono), flettet og fortom.' },
  { term: 'Spinnfiske', definition: 'Aktivt fiske der man kaster ut sluk, wobbler eller jigg og sveiver inn.' },
  { term: 'Tafs', definition: 'Sterk forfangsbit, ofte av stål eller tykk fluorocarbon, som tåler skarpe tenner (f.eks. gjedde).' },
  { term: 'Uttak', definition: 'Når fisken tar ut snøre fra snella i en rush, ofte med bremselyd.' },
  { term: 'Vad', definition: 'Å vasse ut i vannet, gjerne med vadebukse, for å nå bedre fiskeplasser.' },
  { term: 'Wobbler', definition: 'Fiskeformet agn med skje foran som gir vraltende, dykkende bevegelse.' },
  { term: 'Woke / oppdrift', definition: 'Hvor høyt eller dypt et agn går i vannet, styrt av vekt og fart.' },
];
